import React from 'react';

const Vue_BuiltIn_Attributes = () => {
  return (
    <div>
      <h1>Vue_BuiltIn_Attributes Component</h1>
      <p>This is the Vue_BuiltIn_Attributes tutorial page.</p>
    </div>
  );
}

export default Vue_BuiltIn_Attributes;
